import { CustomerStoreService } from './customer';

export const services = [CustomerStoreService];

export * from './customer';
